import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 4px;
  flex-wrap: wrap;
`;
